<template>
    <div v-if="!isOnline" class="connection-status has-text-danger">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2.28 3L1 4.27l2.47 2.47A14.91 14.91 0 0 0 1 9l1.5 1.5A12.91 12.91 0 0 1 5.1 8.1l1.56 1.56A10.91 10.91 0 0 0 4.5 11L6 12.5a8.91 8.91 0 0 1 2.81-1.94l1.68 1.68A6.91 6.91 0 0 0 7.5 14L9 15.5a4.91 4.91 0 0 1 3-1.45V17l4.27 4.27.73-.73L3 3l-.72-.72zM12 5C8.95 5 6.18 6.08 4.05 7.93l1.42 1.42A10.94 10.94 0 0 1 12 7a10.94 10.94 0 0 1 7.5 2.97l1.42-1.42A12.94 12.94 0 0 0 12 5zm0 4a8.94 8.94 0 0 0-5.5 1.9l1.44 1.44A6.94 6.94 0 0 1 12 11a6.94 6.94 0 0 1 3.5.97l1.06-1.06A8.94 8.94 0 0 0 12 9zm0 4a4.94 4.94 0 0 0-2.5.72l2.5 2.5 2.5-2.5A4.94 4.94 0 0 0 12 13zm0 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"/>
        </svg>
        <span>Offline</span>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const isOnline = ref(navigator.onLine)

const handleOnline = () => isOnline.value = true
const handleOffline = () => isOnline.value = false

onMounted(() => {
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)
})

onUnmounted(() => {
    window.removeEventListener('online', handleOnline)
    window.removeEventListener('offline', handleOffline)
})
</script>

<style scoped>
.connection-status {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 500;
    opacity: 0.85;
    z-index: 9999;
    transition: background-color 0.3s, color 0.3s;
    user-select: none;
    pointer-events: none;
}
</style>
